/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { ElevatedFormTemplateCreateDto } from '../models/elevated-form-template-create-dto';
import { ElevatedFormTemplateDtoBaseResponse } from '../models/elevated-form-template-dto-base-response';
import { ElevatedFormTemplateDtoIReadOnlyListBaseResponse } from '../models/elevated-form-template-dto-i-read-only-list-base-response';
import { ElevatedFormTemplateRevisionDtoBaseResponse } from '../models/elevated-form-template-revision-dto-base-response';
import { ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse } from '../models/elevated-form-template-revision-dto-i-read-only-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class ElevatedFormTemplateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiElevatedFormTemplatesGet
   */
  static readonly ApiElevatedFormTemplatesGetPath = '/api/elevated/form-templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesGet$Plain$Response(params?: {
    includeInactive?: boolean;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesGetPath, 'get');
    if (params) {
      rb.query('includeInactive', params.includeInactive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesGet$Plain(params?: {
    includeInactive?: boolean;
  }): Observable<ElevatedFormTemplateDtoIReadOnlyListBaseResponse> {

    return this.apiElevatedFormTemplatesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>) => r.body as ElevatedFormTemplateDtoIReadOnlyListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesGet$Json$Response(params?: {
    includeInactive?: boolean;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesGetPath, 'get');
    if (params) {
      rb.query('includeInactive', params.includeInactive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesGet$Json(params?: {
    includeInactive?: boolean;
  }): Observable<ElevatedFormTemplateDtoIReadOnlyListBaseResponse> {

    return this.apiElevatedFormTemplatesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateDtoIReadOnlyListBaseResponse>) => r.body as ElevatedFormTemplateDtoIReadOnlyListBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesPost
   */
  static readonly ApiElevatedFormTemplatesPostPath = '/api/elevated/form-templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesPost$Plain$Response(params?: {
    body?: ElevatedFormTemplateCreateDto
  }): Observable<StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesPost$Plain(params?: {
    body?: ElevatedFormTemplateCreateDto
  }): Observable<ElevatedFormTemplateDtoBaseResponse> {

    return this.apiElevatedFormTemplatesPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>) => r.body as ElevatedFormTemplateDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesPost$Json$Response(params?: {
    body?: ElevatedFormTemplateCreateDto
  }): Observable<StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesPost$Json(params?: {
    body?: ElevatedFormTemplateCreateDto
  }): Observable<ElevatedFormTemplateDtoBaseResponse> {

    return this.apiElevatedFormTemplatesPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateDtoBaseResponse>) => r.body as ElevatedFormTemplateDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesIdFullGet
   */
  static readonly ApiElevatedFormTemplatesIdFullGetPath = '/api/elevated/form-templates/{id}/full';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdFullGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdFullGet$Plain$Response(params: {
    id: number;
    version?: number;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdFullGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('version', params.version, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdFullGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdFullGet$Plain(params: {
    id: number;
    version?: number;
  }): Observable<ElevatedFormTemplateRevisionDtoBaseResponse> {

    return this.apiElevatedFormTemplatesIdFullGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdFullGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdFullGet$Json$Response(params: {
    id: number;
    version?: number;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdFullGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('version', params.version, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdFullGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdFullGet$Json(params: {
    id: number;
    version?: number;
  }): Observable<ElevatedFormTemplateRevisionDtoBaseResponse> {

    return this.apiElevatedFormTemplatesIdFullGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesTemplateIdRevisionsGet
   */
  static readonly ApiElevatedFormTemplatesTemplateIdRevisionsGetPath = '/api/elevated/form-templates/{templateId}/revisions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdRevisionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsGet$Plain$Response(params: {
    templateId: number;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdRevisionsGetPath, 'get');
    if (params) {
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdRevisionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsGet$Plain(params: {
    templateId: number;
  }): Observable<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdRevisionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdRevisionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsGet$Json$Response(params: {
    templateId: number;
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdRevisionsGetPath, 'get');
    if (params) {
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdRevisionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsGet$Json(params: {
    templateId: number;
  }): Observable<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdRevisionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoIReadOnlyListBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesTemplateIdRevisionsPost
   */
  static readonly ApiElevatedFormTemplatesTemplateIdRevisionsPostPath = '/api/elevated/form-templates/{templateId}/revisions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdRevisionsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsPost$Plain$Response(params: {
    templateId: number;
    body?: ElevatedFormTemplateCreateDto
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdRevisionsPostPath, 'post');
    if (params) {
      rb.path('templateId', params.templateId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdRevisionsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsPost$Plain(params: {
    templateId: number;
    body?: ElevatedFormTemplateCreateDto
  }): Observable<ElevatedFormTemplateRevisionDtoBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdRevisionsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdRevisionsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsPost$Json$Response(params: {
    templateId: number;
    body?: ElevatedFormTemplateCreateDto
  }): Observable<StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdRevisionsPostPath, 'post');
    if (params) {
      rb.path('templateId', params.templateId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdRevisionsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElevatedFormTemplatesTemplateIdRevisionsPost$Json(params: {
    templateId: number;
    body?: ElevatedFormTemplateCreateDto
  }): Observable<ElevatedFormTemplateRevisionDtoBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdRevisionsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElevatedFormTemplateRevisionDtoBaseResponse>) => r.body as ElevatedFormTemplateRevisionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesTemplateIdActivatePost
   */
  static readonly ApiElevatedFormTemplatesTemplateIdActivatePostPath = '/api/elevated/form-templates/{templateId}/activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdActivatePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdActivatePost$Plain$Response(params: {
    templateId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdActivatePostPath, 'post');
    if (params) {
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdActivatePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdActivatePost$Plain(params: {
    templateId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdActivatePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesTemplateIdActivatePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdActivatePost$Json$Response(params: {
    templateId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesTemplateIdActivatePostPath, 'post');
    if (params) {
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesTemplateIdActivatePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesTemplateIdActivatePost$Json(params: {
    templateId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesTemplateIdActivatePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesIdDeactivatePost
   */
  static readonly ApiElevatedFormTemplatesIdDeactivatePostPath = '/api/elevated/form-templates/{id}/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdDeactivatePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDeactivatePost$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdDeactivatePostPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdDeactivatePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDeactivatePost$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesIdDeactivatePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdDeactivatePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDeactivatePost$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdDeactivatePostPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdDeactivatePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDeactivatePost$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesIdDeactivatePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiElevatedFormTemplatesIdDelete
   */
  static readonly ApiElevatedFormTemplatesIdDeletePath = '/api/elevated/form-templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElevatedFormTemplatesIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElevatedFormTemplateService.ApiElevatedFormTemplatesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElevatedFormTemplatesIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElevatedFormTemplatesIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElevatedFormTemplatesIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
